(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const FORM_SELECTOR = '.about-newsletter-form';

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;

      const button = form.querySelector('.about-newsletter-submit');
      if (!button) return;

      button.disabled = true;
      button.classList.add('is-loading');

      if (button.dataset.loadingText) {
        button.textContent = button.dataset.loadingText;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-offers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');

    const init = (section) => {
      if (section.dataset.flashReady === 'true') return;
      section.dataset.flashReady = 'true';

      // Countdown: hides the whole block once the offer ends.
      const end = Number(section.dataset.end) * 1000;
      const units = {
        days: section.querySelector('[data-unit="days"]'),
        hours: section.querySelector('[data-unit="hours"]'),
        minutes: section.querySelector('[data-unit="minutes"]'),
        seconds: section.querySelector('[data-unit="seconds"]'),
      };
      const daysWraps = section.querySelectorAll('[data-unit-wrap="days"]');

      if (end > 0 && units.seconds) {
        let timer;
        const tick = () => {
          const left = Math.max(0, end - Date.now());
          if (left <= 0) {
            window.clearInterval(timer);
            section.hidden = true;
            return;
          }
          const total = Math.floor(left / 1000);
          const days = Math.floor(total / 86400);
          units.days.textContent = pad(days);
          units.hours.textContent = pad(Math.floor((total % 86400) / 3600));
          units.minutes.textContent = pad(Math.floor((total % 3600) / 60));
          units.seconds.textContent = pad(total % 60);
          daysWraps.forEach((el) => { el.hidden = days === 0; });
        };
        tick();
        timer = window.setInterval(tick, 1000);
      }

      // Arrows scroll the track by one card.
      const track = section.querySelector('[data-flash-track]');
      const prev = section.querySelector('[data-flash-prev]');
      const next = section.querySelector('[data-flash-next]');
      if (!track || !prev || !next) return;

      const step = () => {
        const card = track.querySelector('.flash-card');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      };
      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    };

    const initAll = () => document.querySelectorAll('[data-flash-offers]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-favoritos"]) return;
  try {
    
  (() => {
    if (customElements.get('favorites-list')) return;

    // Reserva caso o script do coração não carregue: mesma chave e mesmo evento dele.
    const STORAGE_KEY = 'carraro:favoritos';
    const fallbackFavorites = {
      read() {
        try {
          const list = JSON.parse(localStorage.getItem(STORAGE_KEY));
          return Array.isArray(list) ? list : [];
        } catch (error) {
          return [];
        }
      },
      write(list) {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
        } catch (error) {
          // Storage can be blocked (e.g. private mode); favorites then are not kept.
        }
        document.dispatchEvent(new CustomEvent('favorites:change', { detail: { list } }));
      },
    };
    const store = () => window.CarraroFavorites || fallbackFavorites;

    class FavoritesList extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.favoritos__grid');
        this.status = this.querySelector('.favoritos__status');
        this.empty = this.querySelector('.favoritos__empty');
        this.handleChange = () => this.prune();
        document.addEventListener('favorites:change', this.handleChange);
        this.load();
      }

      disconnectedCallback() {
        document.removeEventListener('favorites:change', this.handleChange);
      }

      async load() {
        // The storage helper is defined together with the heart button; wait for it for up to 3 s.
        await Promise.race([
          customElements.whenDefined('favorite-button'),
          new Promise((resolve) => setTimeout(resolve, 3000)),
        ]);
        const favorites = store();
        const handles = favorites.read();
        const cards = await Promise.all(handles.map((handle) => this.fetchCard(handle)));

        // Forget products that no longer exist.
        const found = handles.filter((handle, index) => cards[index]);
        if (found.length !== handles.length) favorites.write(found);

        cards.forEach((card, index) => {
          if (!card) return;
          card.dataset.favoriteHandle = handles[index];
          this.grid.append(card);
        });
        this.status.hidden = true;
        this.toggleEmpty();
      }

      async fetchCard(handle) {
        try {
          const response = await fetch(`/products/${encodeURIComponent(handle)}?view=favorito-card`);
          if (!response.ok) return null;
          const template = document.createElement('template');
          template.innerHTML = (await response.text()).trim();
          return template.content.querySelector('.product-card-wrapper');
        } catch (error) {
          return null;
        }
      }

      prune() {
        const handles = store().read();
        this.grid.querySelectorAll('[data-favorite-handle]').forEach((card) => {
          if (!handles.includes(card.dataset.favoriteHandle)) card.remove();
        });
        this.toggleEmpty();
      }

      toggleEmpty() {
        this.empty.hidden = this.grid.children.length > 0;
      }
    }

    customElements.define('favorites-list', FavoritesList);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero-carraro"]) return;
  try {
    
  (() => {
    if (customElements.get('pdp-flash')) return;
    const pad = (n) => String(n).padStart(2, '0');

    class PdpFlash extends HTMLElement {
      connectedCallback() {
        this.end = Number(this.dataset.end) * 1000;
        this.days = this.querySelector('[data-flash-days]');
        this.hours = this.querySelector('[data-flash-hours]');
        this.minutes = this.querySelector('[data-flash-minutes]');
        this.seconds = this.querySelector('[data-flash-seconds]');
        if (!this.end || !this.seconds) return;
        this.tick();
        this.timer = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      tick() {
        const left = Math.max(0, this.end - Date.now());
        if (left <= 0) {
          window.clearInterval(this.timer);
          this.hidden = true;
          return;
        }
        const total = Math.floor(left / 1000);
        const days = Math.floor(total / 86400);
        if (this.days) {
          this.days.hidden = days === 0;
          this.days.textContent = `${days}d`;
        }
        this.hours.textContent = pad(Math.floor((total % 86400) / 3600));
        this.minutes.textContent = pad(Math.floor((total % 3600) / 60));
        this.seconds.textContent = pad(total % 60);
      }
    }

    customElements.define('pdp-flash', PdpFlash);
  })();

  (() => {
    if (customElements.get('pdp-coupon')) return;

    class PdpCoupon extends HTMLElement {
      connectedCallback() {
        this.code = this.dataset.code || '';
        this.button = this.querySelector('button');
        this.action = this.querySelector('[data-coupon-action]');
        this.status = this.querySelector('[data-coupon-status]');
        if (!this.code || !this.button) return;

        if (this.isAlreadyApplied()) this.setState('applied');

        this.onClick = () => (this.classList.contains('is-applied') ? this.remove() : this.apply());
        this.button.addEventListener('click', this.onClick);

      }

      disconnectedCallback() {
        if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
        clearTimeout(this.resetTimer);
      }

      isAlreadyApplied() {
        const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
        if (!match) return false;
        try {
          return decodeURIComponent(match[1]).toUpperCase() === this.code.toUpperCase();
        } catch (_) {
          return false;
        }
      }

      setState(state) {
        this.classList.remove('is-busy', 'is-applied', 'is-error', 'is-fresh');
        if (state) this.classList.add(`is-${state}`);
        const texts = { busy: 'Aplicando\u2026', removing: 'Removendo\u2026', applied: 'Aplicado \u2713', error: 'Tente de novo' };
        if (this.action) {
          if (state === 'applied') {
            this.action.innerHTML =
              '<span class="pdp-coupon__state--default">Aplicado \u2713</span><span class="pdp-coupon__state--hover">\u00d7 Remover</span>';
          } else {
            this.action.textContent = texts[state] || 'Aplicar';
          }
        }
        if (this.status) {
          this.status.textContent =
            state === 'applied' ? `Cupom ${this.code} aplicado` : state === 'error' ? 'N\u00e3o foi poss\u00edvel atualizar o cupom' : '';
        }
        this.button.setAttribute(
          'aria-label',
          state === 'applied' ? `Cupom ${this.code} aplicado. Clique para remover` : `Aplicar cupom ${this.code}`
        );
      }

      async apply() {
        if (this.classList.contains('is-busy') || this.classList.contains('is-applied')) return;
        this.setState('busy');

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const code = encodeURIComponent(this.code);

        try {
          // Stores the code on the session (discount_code cookie) so checkout applies it.
          const sessionResponse = await fetch(`${root}discount/${code}?redirect=${encodeURIComponent(root + 'cart.js')}`, {
            credentials: 'same-origin',
          });

          // Also attach it to the cart itself, so cart totals reflect it right away.
          const cartResponse = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: this.code }),
          }).catch(() => null);

          if (!sessionResponse.ok && !(cartResponse && cartResponse.ok)) throw new Error('coupon');

          this.setState('applied');
          // Keep showing "Aplicado" until the pointer leaves; only then can hover offer "Remover".
          this.classList.add('is-fresh');
          this.button.addEventListener('mouseleave', () => this.classList.remove('is-fresh'), { once: true });
          this.button.addEventListener('blur', () => this.classList.remove('is-fresh'), { once: true });
          document.dispatchEvent(new CustomEvent('carraro:coupon-applied', { detail: { code: this.code } }));
        } catch (_) {
          this.setState('error');
          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => this.setState(null), 2500);
        }
      }

      async remove() {
        if (!this.classList.contains('is-applied') || this.classList.contains('is-busy')) return;
        this.classList.add('is-busy');
        if (this.action) this.action.textContent = 'Removendo\u2026';

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        try {
          const cartResponse = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: '' }),
          });
          if (!cartResponse.ok) throw new Error('coupon');

          // Drop the session code too, so checkout stops applying it.
          document.cookie = 'discount_code=; path=/; max-age=0';

          this.setState(null);
          if (this.status) this.status.textContent = `Cupom ${this.code} removido`;
          document.dispatchEvent(new CustomEvent('carraro:coupon-removed', { detail: { code: this.code } }));
          this.button.focus();
        } catch (_) {
          this.setState('applied');
          if (this.status) this.status.textContent = 'N\u00e3o foi poss\u00edvel remover o cupom';
        }
      }
    }

    customElements.define('pdp-coupon', PdpCoupon);
  })();

  } catch(e) { console.error(e); }
})();
})();
